import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ISupportUserRegistrationAuthClient,
} from 'interfaceAdapter/gatewaySchemas/ISupportUserRegistrationAuthClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/user_registration_auth`;

export class SupportUserRegistrationAuthClient implements ISupportUserRegistrationAuthClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { urlId, fromInvite = false } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            url_id: urlId,
            from_invite: fromInvite,
        });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            const status = response.status;
            const { data, message } = await response.json();

            return {
                data,
                message,
                status,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
